// helper/getImageWithTranslations.ts

type WithTranslationsImage = {
  cover_image?: string | null;
  translated_cover_image?: string | null;
};

export const getCardImage = (
  item: WithTranslationsImage | null | undefined,
  langCode?: string | null
): string => {
  if (!item) return "";

  const cover = item.cover_image || "";
  const translated = item.translated_cover_image || "";

  if (langCode === "AZ") {
    // AZ dilində əsasən cover_image göstər
    return cover || translated;
  }

  // Digər dillərdə əsasən translated_cover_image göstər
  return translated || cover;
};
